import React from 'react';
import { Link } from 'react-router-dom';
import DeleteButton from '../../elements/list/DeleteButton';
import $ from 'jquery';
import Select2 from 'select2';
import Select2Style from 'styles/select2.css';
import ModalDialog from '../../elements/modal/ModalDialog';
import DatetimepickerCSS from 'styles/bootstrap/bootstrap-datetimepicker.css';
import BootstrapDateTimePicker from "eonasdan-bootstrap-datetimepicker"

export default class AddNewCustomerGroup extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false
    };
  }

  openModal(e) {
    e.preventDefault();
    this.setState({
      showModal: true
    })
  }

  onClose() {
    this.setState({
      showModal: false
    })
  }

  componentDidMount() {
    $(this.refs.element).find('select').select2({
      minimumResultsForSearch: -1,
    });
    $('#datetimepicker1').datetimepicker();
    $('#datetimepicker2').datetimepicker();
  }
  render() {
    return (
      <div className="credit-card-management">
        <ModalDialog show={this.state.showModal} onClose={this.onClose.bind(this)} style={{position: 'relative', backgroundColor: 'transparent' }}>
          <img src="/img/push-notification.png" alt="" style={{maxHeight: '500px', display: 'block', margin: 'auto'}}/>
        </ModalDialog>
        <div className="activated-cards">
          <div className="dark-blur"></div>
          <div className="box-header">
            <h2><i className="fa fa-users"></i> Add New Customer Group </h2>
          </div>
          <div className="push" ref="element">
            <form action="">
              <label htmlFor="title">Choose name</label>
              <input type="text" id="title" placeholder="" />
              <label htmlFor="text">Filter (JSON formatted)</label>
              <textarea name="" id="text" cols="" rows="5"></textarea>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button className="button" style={{width: 140}}>Cancel</button>
                <button className="button" onClick={(e) => this.openModal(e)} style={{width: 140}}>Calculate</button>
                <button className="button" style={{width: 140}}>Create</button>
              </div>
            </form>
          </div>
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/push/AddNewCustomerGroup.js